module.exports = __webpack_public_path__ + "img/delete-sentosa.182aaf56.svg";